// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons--27l0BXpPmN","icon":"icon--2_p7N5MFxE"};